import moment from 'moment';
import {
  convertBusinessTypeIdtoString,
  convertBusinessCategoryIdtoString,
} from './capitalHelperDto';

export function createTaraliteDto(
  form,
  businessTypeEnum,
  businessCategoryEnum
) {
  // map businessTypeId and businessCategoryId to it's string, these 2 datas are in reducer
  let businessType = convertBusinessTypeIdtoString(
    form.business_type,
    businessTypeEnum
  );
  businessType = businessType ? businessType.split('&').join('') : businessType;
  let businessCategory = convertBusinessCategoryIdtoString(
    form.business_category,
    businessCategoryEnum
  );
  businessCategory = businessCategory
    ? businessCategory.split('&').join('')
    : businessCategory;

  return {
    loan_amount: form.pre_approved_amount,
    loan_duration: form.duration,
    interest_rate: form.interest_rate,
    loan_purpose: form.loan_purpose,
    first_name: form.first_name,
    last_name: form.last_name,
    email: form.email,
    phone_number: `+62${form.phone_number}`,
    ktp: form.nik,
    npwp: form.npwp_no,
    gender_type: form.gender,
    marital_status_type: form.marital_status,
    place_of_birth: form.place_of_birth,
    date_of_birth: form.birth_date
      ? moment(form.birth_date).format('YYYY-MM-DD')
      : form.birth_date,
    mother_name: form.mother_name,
    address: {
      full_address: form.address,
      city: form.home_city,
      province: form.home_province,
      postal_code: form.home_zipcode,
    },
    bank_account: {
      bank_name:
        form.bank_name === 'Other' ? form.other_bank_name : form.bank_name,
      account_number: form.account_no,
      account_holder: form.bank_account_name,
    },
    emergency_contact: {
      full_name: form.name_emergency,
      relationship_type: form.relationship,
      relationship: form.relationship,
      phone_number: `+62${form.contact_number_emergency}`,
    },
    business_detail: {
      business_id: '',
      business_name: form.business_name,
      business_type: businessType,
      business_category: businessCategory,
      join_date: `${form.business_start_year}-${form.business_start_month}-01`,
      address: {
        full_address: form.business_address,
        city: form.business_city,
        province: form.business_province,
        postal_code: form.business_zipcode,
      },
    },
    loan_info: {
      family_card_data_url: form.kk.code,
      ktp_data_url: form.ktp.code,
      verification_photo_data_url: form.verification_photo.code,
    },
    callback_url: '',
  };
}
